import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { IconChevronLeft, spaceMixin, Text, TextButtonMixin, token } from '@zillow/constellation';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  ${TextButtonMixin}
  margin: ${spaceMixin('lg')} 0;
  display: block;
  text-align: initial;
  width: fit-content;

  // Styling following LVHA order
  color: ${token('colors.link')};

  :visited {
    // explicitly not styling as a visited link
    color: ${token('colors.link')};
  }

  // overriding text-decoration of TextButton
  &&&:hover {
    color: ${token('colors.linkHover')};
    text-decoration: none;
  }

  :active {
    color: ${token('colors.linkActive')};
  }
  @media print {
    display: none;
  }
`;

export default function BackLink({ to, children, id = null, className = null }) {
  return (
    <StyledLink buttonType="primary" to={to} id={id} className={className}>
      <Text fontColor="">
        <IconChevronLeft marginRight="sm" />
        {children}
      </Text>
    </StyledLink>
  );
}

BackLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
};
